<template>
  <auth-layout pageClass="login-page">
    <loading :active.sync="isLoading"
      :can-cancel="false"
      :color="'#000000'"
      :is-full-page="false"
      :height="70"
      :width="155"
      :opacity="0.8">
    </loading>
    <div class="row d-flex justify-content-center align-items-center">
      <div class="col-lg-4 col-md-5 col-sm-7">
        <form method="POST" @submit.prevent="validateSubmit">
          <fade-render-transition>
            <card class="card-login">
              <div slot="header" class="text-center card-header-login">
                <img src="/static/img/logo_apc.png" alt="logo" class="img-fluid">
<!--            <a href="https://app.aplicacionescorporativas.com/" target="_blank">
                  <div class="logo-img">
                   </div>
                </a>-->
              </div>
              <div class="login-card-body">
                <fg-input
                  placeholder="Correo Electronico o Usuario"
                  v-validate="modelValidations.login"
                  name="correo electronico o usuario"
                  :error="getError('correo electronico o usuario')"
                  v-model="user.login"
                  ref="user"
                  v-on:keyup="validateKey"
                  type="text">
                </fg-input>
                <fg-input
                  placeholder="Contraseña"
                  v-validate="modelValidations.password"
                  name="contraseña"
                  :error="getError('contraseña')"
                  v-model="user.password"
                  v-on:keyup="validateKey"
                  :type="showPass.inputTypePass"
                  :myCustom="{addon : 'not-input-group-addon'}"
                  class="mb-4">
                  <template slot="addonRight">
                    <l-button @click="showPassword"> <i :class="showPass.iconBtnPass"></i> </l-button>
                  </template>
                </fg-input>
                <fg-input>
                  <l-checkbox v-model="user.remember_me" class="remember-text custom-remember_me">
                    Recuerdame
                  </l-checkbox>
                </fg-input>
              </div>
              <div class="text-center">
                <button id="btnLogin" type="submit" class="btn btn-fill btn-secondary btn-wd" :disabled="btnDisabled">
                  <i class="fa fa-sign-in" aria-hidden="true"></i>  Iniciar Sesión
                </button> <br>
                <button class="btn btn-fill btn-danger btn-wd" @click.prevent="AuthProvider('google')">
                  <i class="fa fa-google-plus" aria-hidden="true"></i> Iniciar con Google
                </button><br><br>
                <div class="forgot">
                  <a @click="showSwalPasswordRequest" class="card-category pointer">
                    ¿Olvidaste tu Contraseña?
                  </a>
                </div>
              </div>
            </card>
          </fade-render-transition>
        </form>
      </div>
    </div>
  </auth-layout>
</template>
<script>
  import axios from 'axios';
  import Vue from 'vue'
  import VueAxios from 'vue-axios'
  import VueSocialauth from 'vue-social-auth'
  import mixinAuth from 'src/util/mixinAuth'
  import showSwalAlert from 'src/util/alerts'
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';

  // Definimos la configuracion basica de vue-social-auth
  Vue.use(VueAxios, axios)
  Vue.use(VueSocialauth, {
    //baseUrl: 'http://127.0.0.1:8000/api', // Your API domain
    baseUrl: 'https://app.aplicacionescorporativas.com/apc-backend/api', // Your API domain
    providers: {
      google: {
        clientId: '1062991320167-9lr0cdhs8fvf48fpt029jnvgttr8ogrm.apps.googleusercontent.com',
        //redirectUri: 'http://localhost:8080/api/auth/google/callback' // Your client app URL
        redirectUri: 'https://app.aplicacionescorporativas.com/apc-backend/api/auth/google/callback' // Your client app URL
      }
    }
  })

  export default {
    components:{
      Loading,
    },
    data () {
      return {
        isLoading: false,
        user: {
          remember_me: false,
        },
        modelValidations: {
          password: {
            required: true,
            min: 8
          }
        },
      }
    },
    mixins: [mixinAuth],
    methods: {
      // este metodo se encagar de llamar nuestra accion login del store
      signin (){
        this.isLoading = true
        this.login(this.user).then((response) => {
          this.$router.push('/').catch(() => {
            if(response.data.success == 200) this.passRequestEmail({ login: response.data.data, password_temporary: true })
          })
        }).catch((error) => {
          this.isLoading = false
          if(error.response.data.message) showSwalAlert(error.response.data.message, 'error')
        })
      },

      // este metodo se encarga de llamar a nuestro proveedor de login
      AuthProvider(provider) {
        var self = this
        this.$auth.authenticate(provider).then(response =>{
          self.SocialLogin(provider,response)
        }).catch(err => {
          console.log( {error : err} )
        })
      },

      // realizamos una peticion a la api con los datos del proveedor
      SocialLogin(provider,response){
        this.$http.post('/auth/sociallogin/'+provider,response).then(response => {
          this.loginGoogle(response.data.data.access_token).then(() => {
            this.$router.push('/').catch(() => {
              if(response.data.success == 200) this.passRequestEmail({ login: response.data.data, password_temporary: true })
            })
          })
        }).catch(error => {
          console.log({error :error})
        })
      },

      validateSubmit () {
        this.$validator.validateAll().then(isValid => {
          if(isValid) {
            this.btnDisabled = false
            this.signin()
          }
          else this.btnDisabled = true
        })
      },

      // este metodo se encarga de mostrar un alert para solicitar cambio de contraseña
      showSwalPasswordRequest () {
        showSwalAlert('Restablecer Contraseña', 'input', 'Enviar Enlace', null, {type:'text', placeholder:'Correo Electronico o Usuario'})
          .then(function (result) {
            if(result.value) this.passRequestEmail({ login: result.value })
          }.bind(this)).catch((error) => console.log(error))
      },

      // llamamos a nuestra accion pasandole por parametro el email del usuario
      passRequestEmail (user) {
        this.passwordRequest(user).then((response) => {
          if(user.password_temporary) {
            showSwalAlert('Cambiar Contraseña', 0, 'Continuar', `<p> ${response.data.message} </p>`).then((result) => {
              if(result.value) this.$router.push('/password_reset/'+response.data.data.token)
            })
          } else {
            showSwalAlert(response.data.message, (response.data.success == 203) ? 'warning' : 'success')
          }
        }).catch((error) => {
          showSwalAlert(error.response.data.message, 'error')
        })
      },

    }
  }
</script>
<style>
  .login-card-body{
    padding: 30px 20px 10px 20px !important;
  }

  .img-fluid{
    margin-top: 20px !important;
  }

  .card-login {
    background-color: #000 !important;
  }
</style>
